/* eslint-disable */
const mutations = {
  setUsers(state, { users }) {
    state.data = users;
  },
};

export default mutations;
